export enum InquirySystem {
	Site = 0,
	Portal = 1,
}

export const InquirySystemName = {
	[InquirySystem.Site]: 'Site',
	[InquirySystem.Portal]: 'Portal',
};
